import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService, UtilsService } from 'core/index';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-customizations',
  templateUrl: './customizations.component.html',
  styleUrls: ['./customizations.component.scss']
})
export class CustomizationsComponent implements OnInit, AfterViewInit, OnDestroy {
  public clientDocumentslistId = 'CLIENT_DOCUMENTS_LIST';
  public clientCustomizationslistId = 'CLIENT_CUSTOMIZATIONS_LIST';
  public tabsManager: any | Subscription = new Subscription();
  public filters: Map<string, string>;
  @ViewChild('tabGroup', { static: false }) public tabGroup: MatTabGroup;

  constructor(public route: ActivatedRoute, public profileService: ProfileService) {}

  public ngOnInit(): void {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      const displayAllElements = ['superAdmin', 'csm', 'supportSpecialist'].find((item) => item === loggedUser.role);
      if (!displayAllElements) {
        this.filters = new Map<string, string>().set('clientId', loggedUser.clientId);
      }
    });
  }

  public ngAfterViewInit(): void {
    this.tabsManager = UtilsService.createTabsManager(this.route, this.tabGroup, {
      position: 0,
      textLabel: 'documents'
    });
  }

  public ngOnDestroy(): void {
    this.tabsManager.unsubscribe();
  }
}
